<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <!-- <template>
                            <div class="text-muted text-center mb-3">
                                <small>Sign in with</small>
                            </div>
                            <div class="btn-wrapper text-center">
                                <base-button type="neutral">
                                    <img slot="icon" src="img/icons/common/github.svg">
                                    Github
                                </base-button>

                                <base-button type="neutral">
                                    <img slot="icon" src="img/icons/common/google.svg">
                                    Google
                                </base-button>
                            </div>
            </template>-->
            <template>
              <div class="text-center text-muted mb-4">
                <small>sign in with credentials</small>
              </div>
              <form role="form">
                <base-input
                  alternative
                  class="mb-3"
                  v-model="loginemail"
                  placeholder="Email"
                  addon-left-icon="ni ni-email-83"
                ></base-input>
                <base-input
                  alternative
                  type="password"
                  v-model="loginpassword"
                  placeholder="Password"
                  addon-left-icon="ni ni-lock-circle-open"
                ></base-input>
                <base-checkbox>Remember me</base-checkbox>
                <div
                  v-show="show"
                  id
                  class="logininfobox alert alert-warning mt-2"
                >{{ loginErrorString }}</div>
                <div
                  v-show="showLoading"
                  id
                  class="logininfobox alert alert-warning mt-2"
                >Please wait...</div>
                <div
                  v-show="showSuccess"
                  id
                  class="logininfobox alert alert-success mt-2"
                >Login succesful, please wait...</div>
                <div class="text-center">
                  <base-button
                    @submit="loginProcess"
                    @click="loginProcess"
                    type="primary"
                    class="my-4"
                  >Sign In</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <small>Forgot password?</small>
              </a>
            </div>
            <div class="col-6 text-right">
              <a href="#/register" class="text-light">
                <small>Create new account</small>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { APIURLS } from "../api/constants.js";
import axios from "axios";

export default {
  name: "Login",
  data() {
    return {
      show: false,
      loginemail: "",
      loginpassword: "",
      showLoading: false,
      showSuccess: false,
      loginErrorString: "Incorrect Username or Password, Please try again",
    };
  },
  methods: {
    logout() {
      localStorage.setItem("userid", "");
      localStorage.setItem("loggedIn", "no");
      localStorage.setItem("customer_id", "");
      localStorage.setItem("email", "");
      localStorage.setItem("name", "");
      localStorage.setItem("user", "");
      //this.$router.push("/");
      this.$root.$emit('loginevent', false);
      
      //this.$router.go(this.$router.currentRoute);
      location.reload(true);
    },
    loginProcess() {
      if (this.loginemail == "" || this.loginpassword == "") {
        this.show = true;

        this.loginErrorString =
          "All fields are required for login, please recheck and continue";
      } else {
        this.showLoading = true;
        this.show = false;
        //this.show = false;
        var formData = new FormData();

        formData.append("email", this.loginemail);
        formData.append("password", this.loginpassword);

        axios.post(APIURLS.LOGIN_URL, formData).then((response) => {
          this.showLoading = false;
          var data = response.data;
          if (data.success) {
            this.showSuccess = true;
            localStorage.setItem("userid", data.user.contact_id);
            localStorage.setItem("loggedIn", "yes");
            localStorage.setItem("customer_id", data.user.customer);
            localStorage.setItem("email", data.user.email);
            localStorage.setItem("name", data.user.name);
            localStorage.setItem("user", data.user);
            this.$root.$emit('loginevent', true);
            this.$router.push("/");
            location.reload(true);
            //this.$router.go(this.$router.currentRoute);
            // window.location.href =
            //   "https://followmetraveller.in/";
            //                         admin: 0
            // contact_id: 28
            // customer: 20
            // email: "sajidyoung2006@gmail.com"
            // is_admin: 0
            // logged_in: true
            // name: "Sajid Mathupotra"
            // surname: ""
          } else {
            this.loginErrorString = data.message;
            this.show = true;
          }
          //console.log(response);
        });
      }

      // this.showLoading = true;
      // if(this.loginemail == '' || this.loginpassword == '') {
      //     this.loginErrorString = "Email/Number and Password both fields are required";
      //     this.show = true;
      //     this.showLoading = false;
      // } else {
      //     this.showLoading = false;
      //     this.show = false;

      // }
    },
  },
  created() {
    if (this.$route.query.l) {
      this.logout();
    }
  },
};
</script>
<style>
</style>
